// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var shareButtonContainer = "ShareButtons-module--share-button-container--3y-_g";